
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C5.05 4.5 3.51 4.72 2.22 5.29C1.49 5.62 1 6.33 1 7.14V18.42C1 19.72 2.22 20.68 3.48 20.36C4.46 20.11 5.5 20 6.5 20C8.06 20 9.72 20.26 11.06 20.92C11.66 21.22 12.34 21.22 12.93 20.92C14.27 20.25 15.93 20 17.49 20C18.49 20 19.53 20.11 20.51 20.36C21.77 20.69 22.99 19.73 22.99 18.42V7.14C22.99 6.33 22.5 5.62 21.77 5.29C20.49 4.72 18.95 4.5 17.5 4.5ZM21 17.23C21 17.86 20.42 18.32 19.8 18.21C19.05 18.07 18.27 18.01 17.5 18.01C15.8 18.01 13.35 18.66 12 19.51V8C13.35 7.15 15.8 6.5 17.5 6.5C18.42 6.5 19.33 6.59 20.2 6.78C20.66 6.88 21 7.29 21 7.76V17.23Z' fill='#323232'/><path d='M13.9799 11.01C13.6599 11.01 13.3699 10.81 13.2699 10.49C13.1399 10.1 13.3599 9.66998 13.7499 9.54998C15.2899 9.04998 17.2799 8.88998 19.1099 9.09998C19.5199 9.14998 19.8199 9.51998 19.7699 9.92998C19.7199 10.34 19.3499 10.64 18.9399 10.59C17.3199 10.4 15.5499 10.55 14.2099 10.98C14.1299 10.99 14.0499 11.01 13.9799 11.01Z' fill='#323232'/><path d='M13.9799 13.67C13.6599 13.67 13.3699 13.47 13.2699 13.15C13.1399 12.76 13.3599 12.33 13.7499 12.21C15.2799 11.71 17.2799 11.55 19.1099 11.76C19.5199 11.81 19.8199 12.18 19.7699 12.59C19.7199 13 19.3499 13.3 18.9399 13.25C17.3199 13.06 15.5499 13.21 14.2099 13.64C14.1299 13.66 14.0499 13.67 13.9799 13.67Z' fill='#323232'/><path d='M13.9799 16.33C13.6599 16.33 13.3699 16.13 13.2699 15.81C13.1399 15.42 13.3599 14.99 13.7499 14.87C15.2799 14.37 17.2799 14.21 19.1099 14.42C19.5199 14.47 19.8199 14.84 19.7699 15.25C19.7199 15.66 19.3499 15.95 18.9399 15.91C17.3199 15.72 15.5499 15.87 14.2099 16.3C14.1299 16.32 14.0499 16.33 13.9799 16.33Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-menu-book`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMenuBook

    ```js
    <b-new-b-icon-menu-book />
    ```
</docs>


